import Vue from 'vue';

/**
 * Event bus para comunicacao entre componentes externos (ex.: BancadaGenIA)
 * e o ChatWidget global montado em App.vue.
 *
 * Eventos:
 *   chat-open-agent: abre o chat com a GenIA pre-selecionada.
 *     payload: agentId (string, ex.: 'genia-cnis')
 */
export const chatBus = new Vue();
